import React from 'react';
import KPICard from '../../components/shared/KPICard';
import StatusPill from '../../components/shared/StatusPill';
import SectionDivider from '../../components/shared/SectionDivider';
import { pgvclKPIs, feeders } from '../../data/mockData';

export default function DiscomGridOps() {
  return (
    <div className="p-6 space-y-6">
      <div className="flex gap-4">
        <KPICard title="Feeder Generation" value={`${pgvclKPIs.feederGenerationMW} MW`} subtext="Total active feeders" />
        <KPICard title="Avg Feeder Voltage" value={`${pgvclKPIs.avgFeederVoltage} V`} subtext="Within ±5% tolerance" subtextColor="green" />
        <KPICard title="Solar Penetration" value={`${pgvclKPIs.solarPenetrationPercent}%`} subtext="Of total feeder load" />
        <KPICard title="Active Alarms" value={pgvclKPIs.activeAlarms} bgColor="bg-orange-50" subtextColor="amber" subtext="PGVCL wide" />
        <KPICard title="SLDC Feed" value="LIVE" bgColor="bg-green-50" subtextColor="green" subtext="Real-time sync active" />
      </div>

      <div className="flex gap-4">
        {/* Feeder map placeholder */}
        <div className="w-[50%] bg-white rounded-card border border-border shadow-card p-4">
          <SectionDivider title="Feeder Map — PGVCL" subtitle="Active feeders by circle" />
          <div className="bg-bg-secondary rounded-input border border-border h-64 flex items-center justify-center">
            <div className="text-center">
              <div className="grid grid-cols-3 gap-3 mb-3">
                {feeders.slice(0, 5).map((f, i) => (
                  <div
                    key={i}
                    className="bg-accent/10 border border-accent/20 rounded-input p-2 text-center cursor-pointer hover:bg-accent/20 transition-colors"
                  >
                    <p className="text-xs font-medium text-accent" style={{ fontSize: 10 }}>{f.name.split(' ')[0]}</p>
                    <p className="text-xs text-text-secondary mt-0.5" style={{ fontSize: 9 }}>{f.generationMW} MW</p>
                  </div>
                ))}
              </div>
              <p className="text-xs text-text-tertiary">GIS feeder map — future phase</p>
            </div>
          </div>
        </div>

        {/* Circle summary table */}
        <div className="flex-1 bg-white rounded-card border border-border shadow-card p-4">
          <SectionDivider title="Feeder Summary" subtitle="PGVCL active feeders" />
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-border">
                <th className="text-left py-2 text-text-tertiary font-medium">Feeder</th>
                <th className="text-left py-2 text-text-tertiary font-medium">Circle</th>
                <th className="text-right py-2 text-text-tertiary font-medium">MW</th>
                <th className="text-right py-2 text-text-tertiary font-medium">Plants</th>
                <th className="text-right py-2 text-text-tertiary font-medium">Penetration</th>
                <th className="text-right py-2 text-text-tertiary font-medium">Alarms</th>
              </tr>
            </thead>
            <tbody>
              {feeders.map(f => (
                <tr key={f.id} className="border-b border-border/50 hover:bg-bg-secondary cursor-pointer">
                  <td className="py-2.5">
                    <p className="font-medium text-text-primary">{f.name}</p>
                    <p className="text-text-tertiary" style={{ fontSize: 10 }}>{f.id}</p>
                  </td>
                  <td className="py-2.5 text-text-secondary">{f.circle}</td>
                  <td className="py-2.5 text-right font-medium text-text-primary">{f.generationMW}</td>
                  <td className="py-2.5 text-right text-text-secondary">{f.plants}</td>
                  <td className="py-2.5 text-right text-text-secondary">{f.penetrationPercent}%</td>
                  <td className={`py-2.5 text-right ${f.alarms > 0 ? 'text-warning font-semibold' : 'text-text-secondary'}`}>{f.alarms}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
